import { render, staticRenderFns } from "./ConsortiumReport.vue?vue&type=template&id=3552ad8a&"
import script from "./ConsortiumReport.vue?vue&type=script&lang=js&"
export * from "./ConsortiumReport.vue?vue&type=script&lang=js&"
import style0 from "./ConsortiumReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports